var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHooplaCircledLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f3f0ff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #7638e2;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M425.3,74.7C378.5,27.9,316.2,2.1,250,2.1S121.5,27.9,74.7,74.7,2.1,183.8,2.1,250s25.8,128.5,72.6,175.3,109.1,72.6,175.3,72.6,128.5-25.8,175.3-72.6c46.8-46.8,72.6-109.1,72.6-175.3s-25.8-128.5-72.6-175.3Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M325.5,308.4l-38.3-20.7c-14.7-8.3-26.8-20.4-35.1-35.1l-20.7-39.9-21.1,38.3c-8.2,15.4-20.7,28.1-36.1,36.4l-37.4,21.1,38.3,21.1c15,7.9,27.2,20.1,35.1,35.1l21.1,39.6,20.7-38.3c8.1-14.8,20.3-27,35.1-35.1l38.3-22.3v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M394.5,194.2l-25.5-13.4c-9.9-5.4-18.1-13.4-23.6-23.3l-13.7-25.5-14,25.5c-5.5,9.8-13.5,17.8-23.3,23.3l-24.3,13.4,25.9,14c9.8,5.5,17.8,13.5,23.3,23.3l14,25.5,13.7-25.5c5.5-9.8,13.7-17.9,23.6-23.3l23.9-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.1,163l-18.8-10.2c-7.2-4-13.1-9.9-16.9-17.2l-10.2-18.5-9.9,18.5c-4,7.3-9.9,13.3-17.2,17.2l-18.8,10.2,18.8,10.2c7.2,4,13.2,10,17.2,17.2l10.2,18.5,10.2-18.5c3.9-7.2,9.8-13.2,16.9-17.2l18.5-10.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHooplaCircledLogo);
export default __webpack_public_path__ + "static/media/hoopla_circled_logo.ee33c983.svg";
export { ForwardRef as ReactComponent };